import type { MapConfig } from './MapTypes';
import { spoxmenLocation } from './DemoConstants';

export const MAP_CONFIG_DEMO1: MapConfig = {
  mapStyle: 'mapbox://styles/spoxmen/cmf01o9o4006001seh6pgdctc',
  mapStates: {
    demoStart: {
      mapState: { latitude: 51.4416, longitude: 5.4697, zoom: 5, bearing: 0, pitch: 45 },
      visibleLayers: [],
      layerVisibilityDelay: 100,
      description: 'Demo starting: Just a map',
      autoAdvanceMs: 5000,
      transitionDuration: 2000,
      visibleDeckGLLayers: []
    },
    eindhoven_zoomed: {
      mapState: { latitude: 51.4416, longitude: 5.4697, zoom: 13, bearing: 0, pitch: 45 },
      visibleLayers: ['S copy 4', 'S copy 5', 'S copy 6', 'merge2-68e66b copy 1'],
      layerVisibilityDelay: 2500,
      description: 'Zoomed in on Eindhoven with the main electricity network visible.',
      autoAdvanceMs: 6000,
      transitionDuration: 5000,
      visibleDeckGLLayers: []
    },
    eindhoven_zoomed2: {
      mapState: { latitude: 51.44059, longitude: 5.47219, zoom: 18, bearing: 0, pitch: 45 },
      visibleLayers: ['S copy 1', 'S copy 2', 'S copy 3', 'S copy 4', 'S copy 5', 'S copy 6', 'merge2-68e66b copy 1'],
      layerVisibilityDelay: 3500,
      description: 'Individual grid connections visible',
      autoAdvanceMs: 7000,
      transitionDuration: 5000,
      visibleDeckGLLayers: []
    },
    denbosch: {
      mapState: { latitude: spoxmenLocation[1], longitude: spoxmenLocation[0], zoom: 15, bearing: 0, pitch: 45 },
      visibleLayers: [],
      layerVisibilityDelay: 4500,
      description: 'Headquarters',
      autoAdvanceMs: 8000,
      transitionDuration: 5000,
      visibleDeckGLLayers: ['LogoLayer', 'EnexisLayer', 'MVTLayer']
    },
    demoEnd: {
      mapState: { latitude: 51.4416, longitude: 5.4697, zoom: 5, bearing: 0, pitch: 45 },
      visibleLayers: [],
      layerVisibilityDelay: 100,
      description: 'End of demo',
      autoAdvanceMs: 5000,
      transitionDuration: 2000,
      visibleDeckGLLayers: []
    },
  },
  switchableLayers: ['S copy 1', 'S copy 2', 'S copy 3', 'S copy 4', 'S copy 5', 'S copy 6', 'merge2-68e66b copy 1'],
  mapSequence: ['demoStart', 'eindhoven_zoomed', 'eindhoven_zoomed2', 'denbosch','demoEnd'],
  initialMapState: 'demoStart'
};
